import { type ReactNode } from "react";

// 상태 배지: 표 안에서 "활성/비활성", "제출/미제출" 같은 이진 상태를 색 텍스트 대신 알약으로 보여준다.
// 색만으로 뜻을 전달하지 않도록 라벨 텍스트를 항상 함께 둔다 (색각 이상 대응).
//   ok   : 정상 완료 (활성·제출·계약 완료)
//   warn : 사람 손이 필요함 (확인 필요·계약 전)
//   idle : 비어 있거나 꺼진 상태 (비활성·미제출·종료)
//   info : 강조가 필요한 중립 정보 (기한 조정 미리보기의 연장 표시 등)
type Tone = "ok" | "warn" | "idle" | "info";

const TONE: Record<Tone, string> = {
  ok: "bg-emerald-50 text-emerald-700 ring-emerald-600/20",
  warn: "bg-amber-50 text-amber-700 ring-amber-600/20",
  idle: "bg-slate-100 text-slate-500 ring-slate-500/15",
  info: "bg-[#DCEFFA] text-[#0F55A7] ring-[#0F55A7]/20",
};

export default function Badge({
  tone = "idle",
  children,
}: {
  tone?: Tone;
  children: ReactNode;
}) {
  return (
    <span
      className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${TONE[tone]}`}
    >
      {children}
    </span>
  );
}
